<div class="legal-page-wrapper">
  <!-- Navigation Header -->
  <div class="legal-page-header">
    <div class="header-content">
      <a href="/dashboard" class="logo-link">
        <img src="assets/img/logo.svg" alt="People Flow Logo" height="40" />
      </a>
    </div>
  </div>

  <div class="legal-document-container">
    <div class="legal-document-content">
      <h1>Zoznam sprostredkovateľov</h1>

    <div class="document-metadata">
      <p><strong>Posledná aktualizácia:</strong> {{ lastUpdated }}</p>
      <p><strong>Verzia:</strong> {{ version }}</p>
    </div>

    <section>
      <h2>Introduction</h2>
      <p>
        This document lists all subprocessors engaged by <strong>SAMETA s.r.o.</strong> (trading as "People Flow") to process
        personal data on behalf of our customers. We maintain this list in accordance with our obligations under the General Data
        Protection Regulation (GDPR) and our Data Processing Agreement.
      </p>
      <p>
        As described in our <a routerLink="/privacy-policy">Privacy Policy</a> and <a routerLink="/terms-of-use">Terms of Service</a>,
        we engage carefully selected third-party service providers to help us deliver and improve the People Flow platform.
      </p>
    </section>

    <section>
      <h2>Notification of Changes</h2>
      <!-- TODO: Decide on notification mechanism and update this section:
        - Option 1: RSS Feed - Customers can subscribe to an RSS feed at [URL] to receive automatic updates
        - Option 2: Email Subscription - Customers can subscribe via email at [URL] to receive notifications
        - Option 3: Email Notification - We will email all customers directly when changes occur
      -->
      <!-- <div class="todo-note">
        <p>
          <strong>TODO:</strong> Decide on notification mechanism and update this section:
        </p>
        <ul>
          <li><strong>Option 1:</strong> RSS Feed - Customers can subscribe to an RSS feed at [URL] to receive automatic updates</li>
          <li><strong>Option 2:</strong> Email Subscription - Customers can subscribe via email at [URL] to receive notifications</li>
          <li><strong>Option 3:</strong> Email Notification - We will email all customers directly when changes occur</li>
        </ul>
      </div> -->
      <p>
        We will provide at least 10 days' prior written notice before engaging any new subprocessor. Customers have the right to
        object to the use of a new subprocessor within this notice period by contacting us at
        <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>.
      </p>
    </section>

    <section>
      <h2>Current Subprocessors</h2>
      <p>
        The following table lists all subprocessors currently engaged by People Flow as of {{ lastUpdated }}:
      </p>

      <div class="subprocessor-list">
        <div class="subprocessor-card" *ngFor="let processor of subprocessors; let i = index">
          <div class="subprocessor-header">
            <div class="subprocessor-number">{{ i + 1 }}</div>
            <h3>{{ processor.name }}</h3>
          </div>

          <div class="subprocessor-details">
            <div class="detail-row">
              <span class="detail-label">Purpose:</span>
              <span class="detail-value">{{ processor.purpose }}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Type of Data Processed:</span>
              <ul class="data-types-list">
                <li *ngFor="let dataType of processor.dataTypes">{{ dataType }}</li>
              </ul>
            </div>

            <div class="detail-note" *ngIf="processor.note">
              <strong>Note:</strong> {{ processor.note }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <h2>Data Transfer Safeguards</h2>
      <p>
        Where subprocessors are located outside the European Economic Area (EEA), we ensure that appropriate safeguards are in
        place to protect your personal data in accordance with GDPR requirements. These safeguards may include:
      </p>
      <ul>
        <li><strong>Standard Contractual Clauses (SCCs):</strong> EU-approved contractual terms that ensure adequate data protection</li>
        <li><strong>Adequacy Decisions:</strong> Countries recognized by the European Commission as providing adequate data protection</li>
        <li><strong>Additional Technical Measures:</strong> Encryption, pseudonymization, and access controls</li>
      </ul>
      <p>
        For more information about our data transfer mechanisms, please see our
        <a routerLink="/privacy-policy">Privacy Policy</a> or contact us at
        <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>.
      </p>
    </section>

    <section>
      <h2>Your Rights</h2>
      <p>
        As a customer of People Flow, you have the right to:
      </p>
      <ul>
        <li>Receive notice of any new subprocessors we intend to engage</li>
        <li>Object to the use of a new subprocessor within the notice period</li>
        <li>Request a copy of the Standard Contractual Clauses we have in place with subprocessors</li>
        <li>Receive information about the security measures implemented by our subprocessors</li>
      </ul>
      <p>
        To exercise any of these rights, please contact us at <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>.
      </p>
    </section>

    <section>
      <h2>Contact Information</h2>
      <p>
        If you have any questions about our subprocessors or data processing practices, please contact us at:
      </p>
      <p>
        <strong>SAMETA s.r.o.</strong><br>
        Čulenova 7936/5<br>
        811 09 Bratislava<br>
        Slovak Republic<br>
        Email: <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
      </p>
    </section>
    </div>
  </div>
</div>
